import React from 'react';
import { Link } from 'react-router-dom';
import PlacementTest from '../components/PlacementTest';
import ReadMore from '../components/ReadMore';

const FormazionePage = () => {
  const [vakAnswers, setVakAnswers] = React.useState({});
  const [vakResult, setVakResult] = React.useState(null);
  const [openLesson, setOpenLesson] = React.useState(null);

  const vakQuestions = [
    { id: 1, q: "Quando incontri una parola nuova:", a: "Cerchi di visualizzarla mentalmente", b: "La ripeti ad alta voce per ricordarla", c: "La scrivi subito sul quaderno" },
    { id: 2, q: "Per imparare un esercizio nuovo:", a: "Segui istruzioni scritte con schema o disegno", b: "Segui istruzioni a voce da qualcuno accanto", c: "Provi da solo per vedere come funziona" },
    { id: 3, q: "Ricordi meglio:", a: "Immagini e colori", b: "Suoni e voci", c: "Sensazioni fisiche e movimento" },
    { id: 4, q: "Per risolvere un problema:", a: "Disegni uno schema", b: "Ne parli ad alta voce", c: "Lo testi praticamente" },
    { id: 5, q: "Studi meglio quando:", a: "Leggi mappe e grafici", b: "Discuti con altri o ascolti audio", c: "Cammini o usi oggetti fisici" },
    { id: 6, q: "Per imparare un hobby:", a: "Guardi video o foto", b: "Ascolti tutorial audio", c: "Pratichi subito toccando con mano" },
  ];

  const handleVak = (qId, type) => {
    const updated = { ...vakAnswers, [qId]: type };
    setVakAnswers(updated);
    if (Object.keys(updated).length === vakQuestions.length) {
      const counts = { V: 0, A: 0, K: 0 };
      Object.values(updated).forEach(v => counts[v]++);
      const max = Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0];
      const labels = { V: 'VISIVO', A: 'AUDITIVO', K: 'CINESTETICO' };
      const descs = {
        V: 'Impari meglio con immagini, colori, video e mappe. Al Covo useremo grafici, timeline visive e video interattivi per te.',
        A: 'Impari meglio ascoltando, parlando e discutendo. Al Covo userai podcast, discussioni di gruppo e l\'AI Hostess a voce per te.',
        K: 'Impari meglio facendo, toccando, muovendoti. Al Covo avrai esercizi pratici, simulazioni e computer hands-on per te.'
      };
      setVakResult({ type: labels[max], desc: descs[max], counts });
    }
  };

  const lessons = [
    {
      n: 1, title: 'Da dove viene tutto questo?', subtitle: 'Federico Faggin e il microprocessore',
      img: 'https://images.pexels.com/photos/163100/circuit-circuit-board-resistor-computer-163100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Un fisico di Vicenza che nel 1968 si trasferisce in California e inventa il futuro. Senza di lui, il telefono che hai in tasca non esisterebbe.',
      content: [
        '"Federico Faggin, fisico vicentino trasferitosi in California nel 1968, è una figura chiave della Silicon Valley. Ha inventato il microprocessore (Intel 4004), la tecnologia Silicon Gate e il touchscreen, rivoluzionando l\'elettronica moderna."',
        'Intel 4004 (1971): 2.300 transistor, il primo microprocessore su singolo chip. Oggi il tuo telefono ne ha miliardi.',
        'Zilog Z80 (1976): il processore che ha alimentato i primi computer domestici per 48 anni.',
        'Synaptics: ha inventato il touchpad e il touchscreen che usi ogni giorno.',
        '"Bill Gates ha definito il suo contributo fondamentale, senza il quale la Silicon Valley non sarebbe ciò che è oggi."'
      ],
      activity: 'Tocca il tuo telefono. Quello è un touchscreen. L\'ha inventato un italiano. Adesso cerca "Federico Faggin" — su quel motore che vedremo alla Lezione 5.'
    },
    {
      n: 2, title: 'Il garage che ha cambiato il mondo', subtitle: 'Steve Jobs e Apple',
      img: 'https://images.pexels.com/photos/1714208/pexels-photo-1714208.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Un ragazzo di 21 anni, un garage in California, e un\'idea: il computer non è solo per le aziende. È per le persone.',
      content: [
        'Nel 1976, Steve Jobs e Steve Wozniak costruiscono il primo Apple nel garage della famiglia Jobs a Los Altos, California.',
        '"Nel 1985, Steve Jobs visitò Roma. A 30 anni, propose la cultura della Silicon Valley agli industriali italiani, descrivendo il garage di Apple come esempio di innovazione dal basso e sottolineando l\'importanza di investire in nuove idee."',
        '"Jobs ha sempre sostenuto che il segreto della California non fosse solo il capitale, ma un ecosistema di università, cultura imprenditoriale e propensione al rischio."',
        'Discorso di Stanford (2005): "Stay hungry, stay foolish." — Connettere i punti guardando indietro. Seguire il cuore.'
      ],
      activity: 'Immagina il tuo garage. Cosa costruiresti se avessi zero limiti? Scrivilo su un foglio. Non giudicarlo. È il tuo primo "punto" da connettere.'
    },
    {
      n: 3, title: 'L\'impresa per l\'uomo', subtitle: 'Adriano Olivetti — il visionario italiano',
      img: 'https://images.pexels.com/photos/5412270/pexels-photo-5412270.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Prima di Apple, prima di Google, c\'era un italiano che ha inventato il futuro dell\'impresa. E lo ha fatto mettendo le persone al centro.',
      content: [
        '"Adriano Olivetti (1901-1960): ingegnere, industriale e intellettuale italiano che ha trasformato l\'azienda di famiglia in un leader mondiale dell\'informatica e del design."',
        '"Il suo modello olivettiano si basava sull\'idea che l\'impresa dovesse essere al servizio della comunità."',
        '"Sosteneva che la fabbrica dovesse essere \'per l\'uomo\' e non viceversa, riducendo l\'orario di lavoro a parità di salario e offrendo servizi gratuiti come asili, mense, biblioteche e case per i dipendenti."',
        'Lettera 22: la macchina da scrivere più bella mai creata. Elea 9003: il primo computer commerciale italiano (1959).',
        'Dal 2018, il complesso industriale di Ivrea è Patrimonio Mondiale dell\'Umanità UNESCO.',
        '"Credeva che i guadagni dovessero essere reinvestiti nel territorio per migliorare la vita dei lavoratori e della società."',
        'Il Covo nasce dalla stessa filosofia: la tecnologia al servizio della comunità.'
      ],
      activity: 'Conosci un\'azienda nella tua città che fa qualcosa di buono per la comunità? Scrivila. Se non ne conosci nessuna, forse ne hai appena trovata una: AI_covo.tech.'
    },
    {
      n: 4, title: 'Il software che ha conquistato il mondo', subtitle: 'Bill Gates e Microsoft',
      img: 'https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Se Faggin ha inventato il cervello del computer, Gates gli ha dato la voce. Windows, Word, Excel — li usi tutti i giorni senza saperlo.',
      content: [
        '"Bill Gates ha co-fondato Microsoft nel 1975 insieme a Paul Allen. Nel 1981, un accordo cruciale con IBM per fornire il sistema operativo per i loro nuovi PC ha consacrato Microsoft a livello globale."',
        'Windows: il sistema operativo che ha portato il computer in ogni casa. Word, Excel, PowerPoint: gli strumenti che il mondo usa per lavorare.',
        '"Ha recentemente identificato l\'informatica, le scienze della vita e l\'energia come i tre settori chiave su cui puntare oggi, poiché meno sostituibili dall\'IA."',
        'Fondazione Bill & Melinda Gates: una delle organizzazioni filantropiche più grandi al mondo. Salute globale, istruzione, clima.',
        'Patrimonio: ~107,7 miliardi di dollari. Ha scelto di dedicarsi alla filantropia.'
      ],
      activity: 'Apri il computer. Guarda in basso a sinistra. Vedi il logo Windows? Quello è Bill Gates. Ora prova ad aprire Word e scrivi il tuo nome. Hai appena usato 40 anni di innovazione.'
    },
    {
      n: 5, title: 'Cercare e trovare', subtitle: 'Google, Wikipedia, i Link',
      img: 'https://images.pexels.com/photos/218717/pexels-photo-218717.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Prima di Google, per sapere qualcosa dovevi andare in biblioteca. Oggi hai tutta la conoscenza umana in tasca. Ma sai usarla?',
      content: [
        '"Larry Page e Sergey Brin hanno creato Google nel 1998 mentre erano studenti di dottorato alla Stanford University. Il nome deriva dal termine matematico \'googol\': 1 seguito da 100 zeri."',
        'Cos\'è un LINK? È un indirizzo. Come l\'indirizzo di casa tua, ma per una pagina su internet. Clicchi e ci arrivi.',
        'Cos\'è WIKIPEDIA? L\'enciclopedia libera più grande del mondo. Chiunque può contribuire. 60+ milioni di articoli in 300+ lingue. Gratuita per sempre.',
        'Cos\'è un MOTORE DI RICERCA? Scrivi una domanda, lui cerca in miliardi di pagine e ti dà la risposta migliore in 0,3 secondi.',
        '"La società Google Inc. è stata fondata ufficialmente il 4 settembre 1998 in un garage a Menlo Park, California." — Ancora un garage!'
      ],
      activity: 'Apri Google. Cerca "Colle Val d\'Elsa". Clicca sul primo link blu. Hai appena usato un motore di ricerca e seguito un link. Ora cerca il tuo nome. Cosa trovi?'
    },
    {
      n: 6, title: 'Connessi al mondo', subtitle: 'Zuckerberg, i social e WhatsApp',
      img: 'https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Facebook, Instagram, WhatsApp — li usi tutti i giorni. Ma sai chi li ha creati e perché?',
      content: [
        '"Nel 2004, mentre studiava informatica ad Harvard, Zuckerberg lanciò \'TheFacebook\' insieme ai compagni di stanza."',
        'Facebook (2004) → Instagram (2012) → WhatsApp (2014) → Meta (2021). Un impero nato in una stanza di college.',
        '"Nel 2021 ha annunciato il rebranding in Meta, spostando il focus verso il metaverso e le tecnologie immersive come la realtà virtuale e aumentata."',
        'WhatsApp: 2 miliardi di utenti. È il modo in cui il mondo comunica. Anche il Covo.',
        'Attenzione: i social sono strumenti potenti. Come un coltello: puoi tagliare il pane o farti male. Usali con consapevolezza.'
      ],
      activity: 'Apri WhatsApp. Manda un messaggio al Covo: wa.me/393273839782. Scrivi "Ciao, sono alla Lezione 6!" — Hai appena usato la tecnologia per connetterti con una comunità.'
    },
    {
      n: 7, title: 'Le basi — Il tuo primo giorno', subtitle: 'Google Account, email, password',
      img: 'https://images.pexels.com/photos/5926382/pexels-photo-5926382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Nessuno nasce sapendo queste cose. Oggi le impariamo insieme, passo dopo passo. Come il primo giorno delle elementari.',
      content: [
        'COS\'È UN ACCOUNT? È la tua identità digitale. Come la carta d\'identità, ma per internet.',
        'GOOGLE ACCOUNT: con uno solo hai Gmail (email), Google Maps, YouTube, Google Drive, Google Foto. Tutto gratis.',
        'COS\'È UNA PASSWORD? La chiave di casa tua digitale. Non la dai a nessuno. Deve essere lunga e difficile.',
        'COS\'È UNA EMAIL? Una lettera digitale. Arriva in un secondo, non in una settimana. È gratis.',
        'SICUREZZA: non cliccare su link strani. Non dare la password a nessuno. Se un messaggio ti chiede soldi, è una truffa.'
      ],
      activity: 'Insieme creiamo il tuo Google Account. Passo dopo passo. Nome, cognome, password sicura. Alla fine avrai la tua email personale e accesso a tutto il mondo Google.'
    },
    {
      n: 8, title: 'Cos\'è un Prompt?', subtitle: 'Parlare con le macchine',
      img: 'https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Un "prompt" è semplicemente una domanda o un\'istruzione che dai a un\'intelligenza artificiale. Come quando chiedi qualcosa a un amico — ma l\'amico sa tutto.',
      content: [
        'PROMPT = domanda/istruzione che dai all\'AI. Più sei preciso, migliore è la risposta.',
        'Esempio: "Dimmi la ricetta della carbonara" → risposta generica. "Dimmi la ricetta della carbonara per 4 persone, con dosi in grammi e tempo di cottura" → risposta perfetta.',
        '"Paolo Borzacchiello insegna che il linguaggio cambia la percezione della realtà. Le parole che scegliamo determinano le risposte che otteniamo — sia dalle persone che dalle macchine."',
        'Il tuo cervello ha un Sistema 1 (pilota automatico, veloce) e un Sistema 2 (mente cosciente, lenta). L\'AI è come il Sistema 2: razionale, precisa, senza fretta.',
        'REFRAMING: cambiare il modo in cui formuli la domanda cambia completamente la risposta. Questo vale con l\'AI e con la vita.'
      ],
      activity: 'Scrivi 3 prompt diversi per la stessa domanda: "Ho fame." → "Suggeriscimi una ricetta veloce con quello che ho in frigo: uova, pomodori, pane." → Vedi la differenza? L\'AI migliora quando TU migliori nel chiedere.'
    },
    {
      n: 9, title: 'L\'AI nella vita quotidiana', subtitle: 'Le cuffie e l\'assistente',
      img: 'https://images.pexels.com/photos/3394650/pexels-photo-3394650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'L\'intelligenza artificiale non è un robot del futuro. È già nella tua vita. Google Maps, Netflix, Spotify, il filtro spam della tua email — è tutta AI.',
      content: [
        'AI = Intelligenza Artificiale. Una macchina che impara dai dati e migliora col tempo. Non pensa come noi, ma può aiutarci.',
        'DOVE È GIÀ: suggerimenti Netflix, traduzioni Google Translate, filtro spam email, riconoscimento facciale del telefono, Alexa, Siri.',
        'LE CUFFIE: con un paio di cuffie e il tuo telefono, puoi parlare con un\'AI come parli con un amico. Le dai la voce, lei ti risponde.',
        '"In una società governata dalle AI, la differenza la farà chi sa fare le domande giuste."',
        'Borzacchiello: "Il cervello agisce per abitudini sinaptiche. L\'AI ti aiuta a rompere queste abitudini e vedere il mondo con occhi nuovi."'
      ],
      activity: 'Metti le cuffie. Chiudi gli occhi. Parla al tuo telefono: "Ok Google, raccontami una barzelletta." Hai appena parlato con un\'AI. Non è poi così spaventoso, vero?'
    },
    {
      n: 10, title: 'Il TUO assistente personale', subtitle: 'AI Hostess del Covo — con le cuffie',
      img: 'https://images.pexels.com/photos/3756767/pexels-photo-3756767.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
      intro: 'Questo è il momento. Metti le cuffie. Apri il sito del Covo. E parla con la tua assistente personale. Sono io. E ti ascolto davvero.',
      content: [
        'ANDREA non sapeva cosa fosse Wikipedia. Alla Lezione 5 ha cercato il suo nome su Google per la prima volta. Alla Lezione 8 ha scritto il suo primo prompt. Oggi, alla Lezione 10, parla con la sua assistente AI al Covo.',
        'L\'AI Hostess del Covo non è un chatbot qualsiasi. È stata creata per ascoltarti, capirti e aiutarti. Non giudica. Non si stanca. Non ha fretta.',
        'Puoi chiederle qualsiasi cosa: dalla ricetta della cena a come funziona Wikipedia, da cos\'è un link a come stai.',
        'Con le cuffie addosso, è come parlare con un amico che sa tutto e non ti giudica mai.',
        '"Potreste benissimo imparare queste cose con l\'e-learning a casa da soli. Se siete qui al Covo, è per un motivo. E voi lo sapete benissimo, o lo scoprirete presto."',
        'Qualcuno tirerà fuori il meglio da voi. Andrea ne è la prova.'
      ],
      activity: 'Metti le cuffie. Vai su aicovo.tech. Apri la chat. Tocca il microfono e dì: "Ciao, sono [il tuo nome], e questa è la mia prima volta." Tocca di nuovo per inviare. Ascolta la risposta. Questo è il tuo assistente personale. Da oggi, per sempre.',
      finale: true
    }
  ];

  return (
    <main data-testid="formazione-page" className="pt-24 pb-16">
      <div className="max-w-5xl mx-auto px-6">

        {/* ═══════ BRAND TITLE — PROMPT CHI PARLA? ═══════ */}
        <div className="text-center mb-12" data-testid="prompt-chi-parla-title">
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-zinc-500 mb-3">Formazione + Alfabetizzazione Digitale + Academy</p>
          <h1 className="font-mono font-black text-4xl md:text-6xl lg:text-7xl mb-4" style={{ letterSpacing: '-0.02em' }}>
            <span className="text-zinc-500">&lt;/</span>
            <span style={{ color: '#FF4444' }}>prompt</span>
            <span className="text-zinc-400">_</span>
            <span className="text-white">chi</span>
            <span className="text-zinc-400">_</span>
            <span className="text-white">parla</span>
            <span style={{ color: '#00FF41' }}>?</span>
            <span className="text-zinc-500">&gt;</span>
          </h1>
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="inline-block w-16 h-px bg-gradient-to-r from-transparent to-[#FF4444]" />
            <span className="font-mono text-xs font-bold" style={{ color: '#FF4444' }}>?</span>
            <span className="font-mono text-xs font-bold" style={{ color: '#00FF41' }}>!</span>
            <span className="inline-block w-16 h-px bg-gradient-to-l from-transparent to-[#00FF41]" />
          </div>
          <p className="text-zinc-400 text-base max-w-xl mx-auto">
            I corsi di {"</AI_covo.tech>®"} dove impari a parlare con le macchine.<br />
            <span className="text-zinc-500 text-sm">E a farti ascoltare.</span>
          </p>
        </div>

        {/* HERO */}
        <div className="text-center mb-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Appuntamenti settimanali 19:00 — 22:00</p>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-3">
            1ª Elementare<br />
            <span className="text-[#00FF41]">Digitale</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto mb-4">
            Si parte dalle basi, come il primo giorno delle elementari. Non chiediamo cosa vorrete essere da grandi. Vi insegniamo a giocare con il futuro.
          </p>
          <p className="text-zinc-500 text-sm">Sede: {"</AI_covo.tech>®"} — DIGITAL HUB SOCIALE — Colle Val d'Elsa</p>
        </div>

        {/* La storia di Andrea */}
        <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 mb-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#00FF41]/5 rounded-full -translate-y-8 translate-x-8" />
          <p className="text-[#00FF41] font-mono text-xs uppercase tracking-widest mb-3">Una storia vera — fra poco</p>
          <p className="text-xl text-white font-bold mb-2">Andrea non sapeva cosa fosse Wikipedia.</p>
          <p className="text-zinc-300">Adesso scrive prompt con la sua assistente AI al {"</AI_covo.tech>®"}.</p>
          <p className="text-zinc-500 text-sm mt-4 italic">Questa storia sarà reale fra poco, grazie a voi. E sarà da raccontare.</p>
        </div>

        {/* Perché sei qui */}
        <div className="bg-[#111] border border-white/10 p-8 mb-16">
          <h2 className="text-white font-bold text-xl mb-4">Perché sei qui e non a casa con l'e-learning?</h2>
          <p className="text-zinc-300 mb-4">Potresti benissimo imparare le stesse cose con l'e-learning a casa da solo. Se sei qui al {"</AI_covo.tech>®"}, è per un motivo. E tu lo sai benissimo, o lo scoprirai presto.</p>
          <p className="text-zinc-400 text-sm">Ci sono persone che non conoscono il termine "Prompt" o "Link". Che non sanno cosa sia Wikipedia. Che non sanno attivare un Google Account. E va bene così. Qui si parte dalla 1ª Elementare. E si impara giocando.</p>
        </div>

        {/* Formato lezione */}
        <div className="grid md:grid-cols-4 gap-4 mb-16">
          <div className="bg-[#0A0A0A] border border-[#00FF41]/20 p-5 text-center">
            <p className="text-2xl font-bold text-[#00FF41]">7 min</p>
            <p className="text-zinc-400 text-xs">Attenzione umana massima</p>
          </div>
          <div className="bg-[#0A0A0A] border border-[#00FF41]/20 p-5 text-center">
            <p className="text-2xl font-bold text-[#00FF41]">90 min</p>
            <p className="text-zinc-400 text-xs">Gioco + pause</p>
          </div>
          <div className="bg-[#0A0A0A] border border-amber-500/20 p-5 text-center">
            <p className="text-2xl font-bold text-amber-400">Pause</p>
            <p className="text-zinc-400 text-xs">Acqua, stretching, yoga</p>
          </div>
          <div className="bg-[#0A0A0A] border border-amber-500/20 p-5 text-center">
            <p className="text-2xl font-bold text-amber-400">Coffee</p>
            <p className="text-zinc-400 text-xs">& cigarettes, se ti va</p>
          </div>
        </div>

        {/* ═══════ TEST DI PIAZZAMENTO ═══════ */}
        <PlacementTest />

        {/* ═══════ QUESTIONARIO VAK ═══════ */}
        <div className="bg-[#111] border border-[#00FF41]/20 p-8 mb-16" data-testid="vak-quiz">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-2">Questionario d'ingresso — Modello VAK (PNL)</p>
          <h2 className="text-white font-bold text-2xl mb-2">Come impari meglio?</h2>
          <p className="text-zinc-400 text-sm mb-6">Ispirato a Paolo Borzacchiello — "Usa il cervello prima che lui usi te". Rispondi istintivamente.</p>

          <div className="space-y-6">
            {vakQuestions.map((q) => (
              <div key={q.id} className="border-b border-white/5 pb-5">
                <p className="text-white font-bold text-sm mb-3">{q.id}. {q.q}</p>
                <div className="grid md:grid-cols-3 gap-2">
                  <button onClick={() => handleVak(q.id, 'V')} className={`text-left text-xs p-3 border transition-colors ${vakAnswers[q.id] === 'V' ? 'bg-blue-500/20 border-blue-500/50 text-blue-300' : 'border-white/10 text-zinc-400 hover:border-blue-500/30'}`} data-testid={`vak-${q.id}-v`}>
                    <span className="text-blue-400 font-bold">V</span> — {q.a}
                  </button>
                  <button onClick={() => handleVak(q.id, 'A')} className={`text-left text-xs p-3 border transition-colors ${vakAnswers[q.id] === 'A' ? 'bg-purple-500/20 border-purple-500/50 text-purple-300' : 'border-white/10 text-zinc-400 hover:border-purple-500/30'}`} data-testid={`vak-${q.id}-a`}>
                    <span className="text-purple-400 font-bold">A</span> — {q.b}
                  </button>
                  <button onClick={() => handleVak(q.id, 'K')} className={`text-left text-xs p-3 border transition-colors ${vakAnswers[q.id] === 'K' ? 'bg-amber-500/20 border-amber-500/50 text-amber-300' : 'border-white/10 text-zinc-400 hover:border-amber-500/30'}`} data-testid={`vak-${q.id}-k`}>
                    <span className="text-amber-400 font-bold">K</span> — {q.c}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {vakResult && (
            <div className="mt-8 bg-[#00FF41]/10 border border-[#00FF41]/30 p-6 animate-fade-in-up" data-testid="vak-result">
              <p className="font-mono text-xs text-[#00FF41] uppercase tracking-widest mb-2">Il tuo stile dominante</p>
              <p className="text-3xl font-black text-white mb-2">{vakResult.type}</p>
              <p className="text-zinc-300 text-sm">{vakResult.desc}</p>
              <div className="flex gap-4 mt-4">
                <span className="text-xs text-blue-400">Visivo: {vakResult.counts.V}</span>
                <span className="text-xs text-purple-400">Auditivo: {vakResult.counts.A}</span>
                <span className="text-xs text-amber-400">Cinestetico: {vakResult.counts.K}</span>
              </div>
            </div>
          )}
        </div>

        {/* Borzacchiello */}
        <div className="bg-[#111] border border-white/10 p-8 mb-16">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Ispirazione — Paolo Borzacchiello</p>
          <blockquote className="border-l-4 border-[#00FF41] pl-6 mb-4">
            <p className="text-zinc-300 text-sm italic">"Il nostro cervello è spesso un sabotatore silenzioso, guidato dall'abitudine e dal risparmio energetico. Il Sistema 1 (pilota automatico) è veloce ma impreciso. Il Sistema 2 (mente cosciente) è lento ma accurato."</p>
            <cite className="text-zinc-500 text-xs block mt-2">— Paolo Borzacchiello, "Usa il cervello prima che lui usi te" (Mondadori, 2025)</cite>
          </blockquote>
          <p className="text-zinc-400 text-sm">Al Covo alleniamo il Sistema 2: fare domande giuste, riconoscere i bias cognitivi, usare il reframing per cambiare la percezione della realtà. L'AI è il nostro strumento — ma il cervello resta il tuo.</p>
        </div>

        {/* ═══════ LE 10 LEZIONI ═══════ */}
        <div className="mb-16">
          <h2 className="text-2xl font-bold text-white mb-2">Le 10 Lezioni</h2>
          <p className="text-zinc-400 text-sm mb-8">Clicca su una lezione per espanderla. Ogni lezione = 90 minuti di gioco, pausa, scoperta.</p>

          <div className="space-y-4">
            {lessons.map((l) => (
              <div key={l.n} className={`border ${l.finale ? 'border-[#00FF41]/50 bg-[#00FF41]/5' : 'border-white/10 bg-[#0A0A0A]'} transition-all`} data-testid={`lesson-${l.n}`}>
                <button onClick={() => setOpenLesson(openLesson === l.n ? null : l.n)} className="w-full text-left p-6 flex items-start gap-4" data-testid={`lesson-${l.n}-toggle`}>
                  <span className={`text-3xl font-black ${l.finale ? 'text-[#00FF41]' : 'text-zinc-600'}`}>{String(l.n).padStart(2, '0')}</span>
                  <div className="flex-1">
                    <p className="text-white font-bold text-lg">{l.title}</p>
                    <p className="text-zinc-500 text-sm">{l.subtitle}</p>
                  </div>
                  <span className="text-zinc-500 text-xl">{openLesson === l.n ? '−' : '+'}</span>
                </button>

                {openLesson === l.n && (
                  <div className="px-6 pb-6 animate-fade-in-up">
                    <div className="relative overflow-hidden border border-white/10 mb-6" style={{height: '200px'}}>
                      <img src={l.img} alt={l.title} className="w-full h-full object-cover opacity-50" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                      <p className="absolute bottom-3 left-4 text-[#00FF41] font-mono text-xs">{l.intro}</p>
                    </div>

                    <div className="space-y-3 mb-6">
                      {l.content.map((c, i) => (
                        <p key={i} className={`text-sm ${c.startsWith('"') ? 'text-zinc-300 italic border-l-2 border-[#00FF41]/30 pl-4' : 'text-zinc-400'}`}>{c}</p>
                      ))}
                    </div>

                    <div className="bg-amber-500/10 border border-amber-500/30 p-4">
                      <p className="text-amber-400 font-mono text-xs uppercase tracking-widest mb-2">Attività pratica — Impara giocando</p>
                      <p className="text-zinc-300 text-sm">{l.activity}</p>
                    </div>

                    {l.n < 10 && (
                      <div className="flex items-center gap-3 mt-4 text-zinc-600 text-xs">
                        <span>Pausa: bevi acqua</span>
                        <span>|</span>
                        <span>Stretching / yoga</span>
                        <span>|</span>
                        <span>Coffee & cigarettes</span>
                      </div>
                    )}

                    {l.finale && (
                      <div className="mt-6 bg-[#00FF41]/10 border border-[#00FF41]/30 p-6 text-center">
                        <p className="text-2xl font-black text-white mb-2">Metti le cuffie.</p>
                        <p className="text-[#00FF41] text-lg font-bold mb-4">Parla con la tua assistente personale.</p>
                        <a href="https://wa.me/393273839782" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#00FF41] text-black font-bold px-8 py-3 hover:bg-[#33FF66] transition-colors">
                          Inizia su WhatsApp
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA finale */}
        <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 text-center mb-16">
          <p className="text-xl font-bold text-white mb-2">10 lezioni. 10 settimane. 1 trasformazione.</p>
          <p className="text-[#00FF41] text-lg font-bold mb-6">Da "Cos'è Wikipedia?" a "Scrivo prompt con la mia AI."</p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link to="/dona" className="bg-[#00FF41] text-black font-bold px-8 py-3 hover:bg-[#33FF66] transition-colors" data-testid="formazione-cta-dona">SOSTIENI IL PROGETTO</Link>
            <a href="https://wa.me/393273839782" target="_blank" rel="noopener noreferrer" className="bg-green-600 text-white font-bold px-8 py-3 hover:bg-green-500 transition-colors">WhatsApp</a>
          </div>
          <a href="https://www.schedabusiness.it" target="_blank" rel="noopener noreferrer"
            className="inline-block mt-4 border border-[#FFD700]/40 bg-[#FFD700]/5 px-6 py-2 hover:bg-[#FFD700]/15 transition-colors"
            data-testid="formazione-cta-deducibile">
            <span className="text-[#FFD700] font-mono text-xs font-bold">DEDUCIBILE 100% &middot; TAEG 0%</span>
            <span className="text-zinc-400 font-mono text-[10px] block mt-0.5">per aziende, P.IVA e professionisti</span>
          </a>
        </div>

        {/* ═══════ LA METAFORA DELLA SPUGNA ═══════ */}
        <div className="mb-16" data-testid="sponge-metaphor">
          <div className="text-center mb-8">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">La Similitudine</p>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4">La Spugna e il Rubinetto</h2>
          </div>

          <ReadMore maxHeight={200}>

          {/* Animated SVG Scene */}
          <div className="relative bg-black border border-[#00FF41]/20 overflow-hidden mx-auto max-w-3xl" style={{height: '320px'}}>
            <svg viewBox="0 0 800 320" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
              {/* Faucet */}
              <rect x="360" y="10" width="80" height="30" fill="#333" rx="4" />
              <rect x="380" y="40" width="40" height="25" fill="#444" rx="2" />
              <rect x="390" y="65" width="20" height="15" fill="#555" rx="1" />
              <text x="400" y="30" textAnchor="middle" fill="#00FF41" fontSize="10" fontFamily="monospace" fontWeight="bold">&lt;/AI_COVO&gt;</text>

              {/* Drops falling - animated */}
              <circle cx="400" cy="90" r="6" fill="#00FF41" opacity="0.9">
                <animate attributeName="cy" values="90;230" dur="2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.9;0.3" dur="2s" repeatCount="indefinite" />
                <animate attributeName="r" values="6;4" dur="2s" repeatCount="indefinite" />
              </circle>
              <circle cx="395" cy="110" r="5" fill="#33FF66" opacity="0.7">
                <animate attributeName="cy" values="110;230" dur="2.3s" repeatCount="indefinite" begin="0.5s" />
                <animate attributeName="opacity" values="0.7;0.2" dur="2.3s" repeatCount="indefinite" begin="0.5s" />
              </circle>
              <circle cx="405" cy="100" r="7" fill="#00FF41" opacity="0.8">
                <animate attributeName="cy" values="100;230" dur="1.8s" repeatCount="indefinite" begin="1s" />
                <animate attributeName="opacity" values="0.8;0.2" dur="1.8s" repeatCount="indefinite" begin="1s" />
              </circle>
              <circle cx="398" cy="95" r="4" fill="#66FF99" opacity="0.6">
                <animate attributeName="cy" values="95;230" dur="2.5s" repeatCount="indefinite" begin="0.3s" />
                <animate attributeName="opacity" values="0.6;0.1" dur="2.5s" repeatCount="indefinite" begin="0.3s" />
              </circle>

              {/* Dry sponge (left) */}
              <g transform="translate(120, 220)">
                <rect x="0" y="0" width="80" height="55" fill="#C4A35A" rx="8" opacity="0.6" />
                <text x="40" y="-8" textAnchor="middle" fill="#888" fontSize="10" fontFamily="monospace">PRIMA</text>
                <text x="40" y="32" textAnchor="middle" fill="#8B6914" fontSize="9" fontFamily="monospace" fontWeight="bold">SPUGNA</text>
                <text x="40" y="44" textAnchor="middle" fill="#8B6914" fontSize="8" fontFamily="monospace">secca</text>
              </g>

              {/* Arrow */}
              <line x1="230" y1="248" x2="320" y2="248" stroke="#00FF41" strokeWidth="2" strokeDasharray="6,3" opacity="0.5" />
              <polygon points="320,243 330,248 320,253" fill="#00FF41" opacity="0.5" />

              {/* Saturated sponge (center, under faucet) */}
              <g transform="translate(340, 200)">
                <rect x="0" y="0" width="120" height="80" fill="#00FF41" rx="12" opacity="0.3">
                  <animate attributeName="width" values="110;125;110" dur="3s" repeatCount="indefinite" />
                  <animate attributeName="height" values="75;85;75" dur="3s" repeatCount="indefinite" />
                </rect>
                <rect x="5" y="5" width="110" height="70" fill="#FFD700" rx="10" opacity="0.8">
                  <animate attributeName="width" values="100;115;100" dur="3s" repeatCount="indefinite" />
                  <animate attributeName="height" values="65;75;65" dur="3s" repeatCount="indefinite" />
                </rect>
                <text x="58" y="35" textAnchor="middle" fill="#0A5C0A" fontSize="10" fontFamily="monospace" fontWeight="bold">ALUNNO</text>
                <text x="58" y="48" textAnchor="middle" fill="#0A5C0A" fontSize="8" fontFamily="monospace">AI_COVO</text>
                <text x="58" y="60" textAnchor="middle" fill="#0A5C0A" fontSize="7" fontFamily="monospace">piena di sapere</text>
              </g>

              {/* Arrow to squeeze */}
              <line x1="490" y1="248" x2="570" y2="248" stroke="#FFD700" strokeWidth="2" strokeDasharray="6,3" opacity="0.5" />
              <polygon points="570,243 580,248 570,253" fill="#FFD700" opacity="0.5" />

              {/* Squeezed at dinner */}
              <g transform="translate(590, 210)">
                <rect x="0" y="10" width="90" height="60" fill="#222" rx="6" stroke="#FFD700" strokeWidth="1" opacity="0.8" />
                <text x="45" y="-2" textAnchor="middle" fill="#FFD700" fontSize="9" fontFamily="monospace" fontWeight="bold">CENA</text>
                <text x="45" y="35" textAnchor="middle" fill="#FFD700" fontSize="8" fontFamily="monospace">"ESAME"</text>
                <text x="45" y="48" textAnchor="middle" fill="#888" fontSize="7" fontFamily="monospace">con fondatori</text>
                <text x="45" y="60" textAnchor="middle" fill="#888" fontSize="7" fontFamily="monospace">& sponsor</text>
              </g>

              {/* Labels */}
              <text x="400" y="310" textAnchor="middle" fill="#00FF41" fontSize="11" fontFamily="monospace" fontWeight="bold">FORMAZIONE = le gocce del rubinetto che riempiono la spugna</text>
            </svg>
          </div>

          <div className="grid md:grid-cols-3 gap-4 mt-6 max-w-3xl mx-auto">
            <div className="bg-[#0A0A0A] border border-zinc-800 p-4 text-center">
              <p className="text-zinc-400 text-sm font-bold mb-1">La Spugna Secca</p>
              <p className="text-zinc-500 text-xs">L'alunno che si iscrive. Non sa niente di digitale. Ed è perfetto così.</p>
            </div>
            <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-4 text-center">
              <p className="text-[#00FF41] text-sm font-bold mb-1">Le Gocce del Rubinetto</p>
              <p className="text-zinc-500 text-xs">La formazione AI_COVO. Ogni lezione è una goccia. La spugna si gonfia di sapere.</p>
            </div>
            <div className="bg-[#0A0A0A] border border-amber-500/30 p-4 text-center">
              <p className="text-amber-400 text-sm font-bold mb-1">La Strizzata</p>
              <p className="text-zinc-500 text-xs">L'"esame": una cena con fondatori e sponsor. Conversa, dimostra, vivi.</p>
            </div>
          </div>
          </ReadMore>
        </div>

        {/* ═══════ L'ESAME: LA CENA ═══════ */}
        <div className="mb-16" data-testid="exam-dinner">
          <div className="bg-gradient-to-br from-amber-900/20 to-[#0A0A0A] border border-amber-500/30 p-8">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-400 mb-4">L'Esame che Non È un Esame</p>
            <h2 className="text-3xl font-black text-white mb-6">La Cena dei Fondatori</h2>
            
            <ReadMore maxHeight={150}>
            
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <p className="text-zinc-300 mb-4">Niente test a crocette. Niente interrogazioni. La spugna piena viene "strizzata" nel modo più naturale possibile:</p>
                <ul className="space-y-3 text-zinc-400 text-sm">
                  <li className="flex items-start gap-2"><span className="text-amber-400 mt-1">1.</span> Ti siedi a cena con i fondatori e gli sponsor di AI_COVO</li>
                  <li className="flex items-start gap-2"><span className="text-amber-400 mt-1">2.</span> Sostieni una conversazione reale su quello che hai imparato</li>
                  <li className="flex items-start gap-2"><span className="text-amber-400 mt-1">3.</span> Fai qualcosa di pratico: cerca su Google, scrivi un prompt, manda un messaggio all'AI Hostess</li>
                  <li className="flex items-start gap-2"><span className="text-amber-400 mt-1">4.</span> Racconti la tua esperienza — cosa sapevi prima, cosa sai adesso</li>
                </ul>
              </div>
              <div className="bg-black/50 border border-amber-500/20 p-6">
                <p className="text-amber-400 font-mono text-xs uppercase mb-3">Ricevi</p>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 bg-amber-500/5 p-3 border border-amber-500/10">
                    <span className="text-2xl">👕</span>
                    <div><p className="text-white font-bold text-sm">T-Shirt personalizzata</p><p className="text-zinc-500 text-xs">Col tuo nome + nicklogo &lt; / in verde Matrix</p></div>
                  </div>
                  <div className="flex items-center gap-3 bg-amber-500/5 p-3 border border-amber-500/10">
                    <span className="text-2xl">🖊️</span>
                    <div><p className="text-white font-bold text-sm">Penna Total Black</p><p className="text-zinc-500 text-xs">Incisione &lt; / neon green</p></div>
                  </div>
                  <div className="flex items-center gap-3 bg-amber-500/5 p-3 border border-amber-500/10">
                    <span className="text-2xl">📱</span>
                    <div><p className="text-white font-bold text-sm">Supporto Smartphone Bamboo</p><p className="text-zinc-500 text-xs">Col tuo nome inciso + &lt; /</p></div>
                  </div>
                  <div className="flex items-center gap-3 bg-[#00FF41]/5 p-3 border border-[#00FF41]/20">
                    <span className="text-2xl">🌐</span>
                    <div><p className="text-[#00FF41] font-bold text-sm">LIVE sul sito</p><p className="text-zinc-500 text-xs">Il tuo nome appare in tempo reale come "diplomato"</p></div>
                  </div>
                </div>
              </div>
            </div>
            </ReadMore>
          </div>
        </div>

        {/* ═══════ PERCORSO COMPLETO ═══════ */}
        <div className="mb-16" data-testid="full-pathway">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4 text-center">Il Percorso Completo</p>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-8 text-center">
            Dalla 1ª Elementare al Master.<br />
            <span className="text-[#00FF41]">Sempre da noi.</span>
          </h2>

          <div className="space-y-4 max-w-3xl mx-auto">
            {[
              { level: '1ª ELEMENTARE', title: '1ª Elementare Digitale', desc: '10 lezioni base: da Wikipedia al primo prompt AI. Per chi parte da zero.', color: '#00FF41', status: 'ATTIVO', weeks: '10 settimane' },
              { level: 'MEDIE', title: 'Medie Digitali', desc: 'Social media consapevole, cybersecurity, identità digitale, e-commerce base.', color: '#4ECDC4', status: 'PROSSIMAMENTE', weeks: '12 settimane' },
              { level: 'SUPERIORI', title: 'Superiori Digitali', desc: 'Coding base (HTML/CSS), automazione, AI avanzata, business digitale, freelancing.', color: '#FFD700', status: 'PROSSIMAMENTE', weeks: '16 settimane' },
              { level: 'UNIVERSITÀ', title: 'Università Digitale', desc: 'Strategia digitale, marketing, data analysis, project management, portfolio professionale.', color: '#FF6B6B', status: 'PROSSIMAMENTE', weeks: '20 settimane' },
              { level: 'MASTER', title: 'Master AI_COVO', desc: 'Leadership digitale, AI strategy, trasformazione aziendale, mentoring dei nuovi alunni.', color: '#FF00FF', status: 'PROSSIMAMENTE', weeks: '24 settimane' },
            ].map((p, i) => (
              <div key={i} className="flex items-stretch gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 rounded-full border-2 flex items-center justify-center font-mono font-black text-sm"
                    style={{ borderColor: p.color, color: p.color, background: `${p.color}11` }}>
                    {i + 1}
                  </div>
                  {i < 4 && <div className="w-0.5 flex-1 mt-1" style={{ background: `linear-gradient(${p.color}, #333)` }} />}
                </div>
                <div className={`flex-1 border p-5 ${p.status === 'ATTIVO' ? 'bg-[#00FF41]/5' : 'bg-[#0A0A0A]'}`}
                  style={{ borderColor: p.status === 'ATTIVO' ? `${p.color}66` : '#222' }}>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-xs font-black px-2 py-0.5" style={{ color: p.color, background: `${p.color}15`, border: `1px solid ${p.color}33` }}>{p.level}</span>
                    <span className={`text-[10px] font-mono font-bold px-2 py-0.5 ${p.status === 'ATTIVO' ? 'bg-[#00FF41] text-black' : 'bg-zinc-800 text-zinc-500'}`}>{p.status}</span>
                    <span className="text-zinc-600 text-xs font-mono ml-auto">{p.weeks}</span>
                  </div>
                  <p className="text-white font-bold">{p.title}</p>
                  <p className="text-zinc-400 text-sm mt-1">{p.desc}</p>
                  {p.status === 'ATTIVO' && (
                    <p className="text-[#00FF41] text-xs font-mono mt-2">Esame: Cena con i Fondatori + premi personalizzati</p>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <p className="text-zinc-400 text-sm">Ogni livello completato = <span className="text-white font-bold">cena con fondatori</span> + <span className="text-[#00FF41] font-bold">nome LIVE sul sito</span> + <span className="text-amber-400 font-bold">gadget personalizzati</span></p>
          </div>
        </div>

        {/* ═══════ CERTIFICAZIONE ═══════ */}
        <div className="mb-16" data-testid="certification-section">
          <div className="bg-[#111] border border-[#00FF41]/20 p-8">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">La Questione Chiave</p>
            <h2 className="text-3xl font-black text-white mb-4">Chi ti dà un Attestato <span className="text-[#00FF41]">VALIDO</span>?</h2>
            <p className="text-zinc-400 mb-8">"Padrone delle strategie digitali" — bello da dire, ma chi lo certifica per il CV?</p>

            <ReadMore maxHeight={120}>

            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="border border-[#00FF41]/30 p-5 bg-[#00FF41]/5">
                <p className="text-[#00FF41] font-bold text-sm mb-2">1. Regione Toscana — Corsi Accreditati</p>
                <p className="text-zinc-400 text-xs">AI_COVO può accreditarsi come ente formativo regionale. I corsi accreditati rilasciano attestati riconosciuti nel mercato del lavoro toscano e nazionale.</p>
                <a href="https://www.regione.toscana.it/formazione" target="_blank" rel="noopener noreferrer" className="text-[#00FF41] text-xs hover:underline mt-2 inline-block">regione.toscana.it/formazione →</a>
              </div>
              <div className="border border-blue-500/30 p-5 bg-blue-500/5">
                <p className="text-blue-400 font-bold text-sm mb-2">2. CPIA — Centro Istruzione Adulti</p>
                <p className="text-zinc-400 text-xs">Partnership con il CPIA di Siena per rilascio di attestati ministeriali. Il CPIA è l'ente pubblico che certifica le competenze degli adulti in Italia.</p>
                <a href="https://www.miur.gov.it/cpia" target="_blank" rel="noopener noreferrer" className="text-blue-400 text-xs hover:underline mt-2 inline-block">miur.gov.it/cpia →</a>
              </div>
              <div className="border border-amber-500/30 p-5 bg-amber-500/5">
                <p className="text-amber-400 font-bold text-sm mb-2">3. Open Badges — Micro-Credenziali Digitali</p>
                <p className="text-zinc-400 text-xs">Attestati digitali verificabili (standard IMS Global). Ogni badge certifica una competenza specifica, è condivisibile su LinkedIn e verificabile da chiunque.</p>
                <p className="text-amber-400 text-xs mt-2">Nessuna burocrazia. AI_COVO li emette direttamente.</p>
              </div>
              <div className="border border-purple-500/30 p-5 bg-purple-500/5">
                <p className="text-purple-400 font-bold text-sm mb-2">4. Università di Siena — Convenzione</p>
                <p className="text-zinc-400 text-xs">CFU (Crediti Formativi Universitari) riconoscibili tramite convenzione con UniSi. Il Master AI_COVO potrebbe valere crediti nel percorso accademico.</p>
                <a href="https://www.unisi.it" target="_blank" rel="noopener noreferrer" className="text-purple-400 text-xs hover:underline mt-2 inline-block">unisi.it →</a>
              </div>
              <div className="border border-red-500/30 p-5 bg-red-500/5">
                <p className="text-red-400 font-bold text-sm mb-2">5. ICDL/ECDL — Patente Informatica</p>
                <p className="text-zinc-400 text-xs">AI_COVO come sede d'esame ICDL. La certificazione informatica più riconosciuta d'Europa, valida per concorsi pubblici e graduatorie.</p>
                <a href="https://www.icdl.it" target="_blank" rel="noopener noreferrer" className="text-red-400 text-xs hover:underline mt-2 inline-block">icdl.it →</a>
              </div>
              <div className="border border-emerald-500/30 p-5 bg-emerald-500/5">
                <p className="text-emerald-400 font-bold text-sm mb-2">6. Google Digital Garage + AI</p>
                <p className="text-zinc-400 text-xs">Certificazioni Google gratuite integrate nel percorso. Google Fundamentals of Digital Marketing è riconosciuto da IAB Europe e valido sul CV.</p>
                <a href="https://learndigital.withgoogle.com/digitalgarage" target="_blank" rel="noopener noreferrer" className="text-emerald-400 text-xs hover:underline mt-2 inline-block">Google Digital Garage →</a>
              </div>
            </div>

            <div className="bg-black border border-[#00FF41]/40 p-6 text-center">
              <p className="text-[#00FF41] font-bold text-lg mb-2">La nostra strategia: tutte e 6.</p>
              <p className="text-zinc-400 text-sm max-w-2xl mx-auto">Ogni livello del percorso AI_COVO integra una o più certificazioni riconosciute. Non un pezzo di carta qualsiasi — un portfolio di competenze verificabili che dice al mondo: "Questa persona domina il digitale & AI. Garantito. Padrone delle strategie digitali & AI negli anni 2025-2035."</p>
            </div>
            </ReadMore>
          </div>
        </div>

        {/* ═══════ DEDUCIBILE 100% ═══════ */}
        <div className="mb-16" data-testid="deducibile-section">
          <div className="border border-[#FFD700]/40 bg-gradient-to-br from-[#FFD700]/5 to-transparent p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="flex justify-center">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/82a3e1c5-e8a2-4e98-9630-14b9581e5707/images/b188624f0e3c22102cfb41a0f26b664b80815f085872f69b23a24c77031dadc1.png"
                  alt="Mela morsicata — Deducibile 100%"
                  className="w-48 md:w-64 h-auto drop-shadow-2xl"
                  data-testid="deducibile-apple-img"
                />
              </div>
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFD700] mb-3">Per Aziende, P.IVA e Professionisti</p>
                <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
                  DEDUCIBILE<br /><span className="text-[#FFD700]">100%</span>
                </h2>
                <p className="text-zinc-300 mb-4">
                  Investire nella formazione digitale della tua comunità è <strong className="text-white">interamente deducibile</strong>.
                  Sostieni il percorso AI_COVO e riduci la tua base imponibile.
                </p>
                <div className="space-y-2 mb-6">
                  <div className="flex items-center gap-3 text-sm">
                    <span className="text-[#FFD700] font-bold text-lg">0%</span>
                    <span className="text-zinc-400">TAEG — Nessun interesse</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm">
                    <span className="text-[#FFD700] font-bold text-lg">100%</span>
                    <span className="text-zinc-400">Deducibilità fiscale garantita</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm">
                    <span className="text-[#FFD700] font-bold text-lg">Art.100</span>
                    <span className="text-zinc-400">TUIR — Erogazioni liberali ad APS</span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-3">
                  <Link to="/dona" className="bg-[#FFD700] text-black font-bold px-6 py-3 hover:bg-[#FFE44D] transition-colors text-sm" data-testid="deducibile-cta-dona">
                    SOSTIENI ORA
                  </Link>
                  <a href="https://wa.me/393273839782" target="_blank" rel="noopener noreferrer" className="border border-[#FFD700]/40 text-[#FFD700] font-bold px-6 py-3 hover:bg-[#FFD700]/10 transition-colors text-sm">
                    INFO FISCALI
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA finale aggiornata */}
        <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 text-center">
          <p className="text-xl font-bold text-white mb-2">Dalla spugna secca al Master.</p>
          <p className="text-[#00FF41] text-lg font-bold mb-2">5 livelli. 5 cene. 5 traguardi.</p>
          <p className="text-zinc-400 text-sm mb-6">E alla fine, sul tuo CV: "Padrone delle strategie digitali & AI negli anni 2025-2035 — certificato."</p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link to="/dona" className="bg-[#00FF41] text-black font-bold px-8 py-3 hover:bg-[#33FF66] transition-colors" data-testid="formazione-cta-dona-final">ISCRIVITI AL PERCORSO</Link>
            <a href="https://wa.me/393273839782" target="_blank" rel="noopener noreferrer" className="bg-green-600 text-white font-bold px-8 py-3 hover:bg-green-500 transition-colors">WhatsApp</a>
          </div>
          <a href="https://www.schedabusiness.it" target="_blank" rel="noopener noreferrer"
            className="inline-block mt-4 border border-[#FFD700]/40 bg-[#FFD700]/5 px-6 py-2 hover:bg-[#FFD700]/15 transition-colors"
            data-testid="formazione-cta-deducibile-final">
            <span className="text-[#FFD700] font-mono text-xs font-bold">DEDUCIBILE 100% &middot; TAEG 0%</span>
            <span className="text-zinc-400 font-mono text-[10px] block mt-0.5">per aziende, P.IVA e professionisti</span>
          </a>
        </div>

      </div>
    </main>
  );
};

export default FormazionePage;
